import React from 'react';

/** Oberflächen laut README §4.3. */
export type Flaeche = 'glas' | 'stark' | 'innen' | 'akzent';

const KLASSE: Record<Flaeche, string> = {
  glas: 'immo-glas',
  stark: 'immo-glas-stark',
  innen: 'immo-innen',
  akzent: 'immo-akzent',
};

export interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  flaeche?: Flaeche;
  /** Eckenradius in px (Widget 26, Panel 30, Karten 20–26). */
  radius?: number;
  /** Innenabstand in px oder als CSS-Wert. */
  padding?: number | string;
}

export const GlassCard = React.forwardRef<HTMLDivElement, GlassCardProps>(function GlassCard(
  { flaeche = 'glas', radius = 26, padding = 16, className = '', style, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={`${KLASSE[flaeche]} ${className}`}
      style={{ borderRadius: radius, padding, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
});
